var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgRecurringTaskTemplate = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.176 3.04h12.571l-1.165-1.194.83-.846L18 3.64l-2.588 2.64-.83-.846 1.165-1.194H3.177v4.2H2v-4.2c0-.662.527-1.2 1.176-1.2Zm2.242 11.526L4.253 15.76h12.57v-4.2H18v4.2c0 .663-.527 1.2-1.177 1.2H4.253l1.165 1.194-.83.846L2 16.36l1.765-1.8.823-.84.83.846Z",
    fill: "#161616"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.53 9.38H5v1.2h3.53v-1.2ZM5 6.5h5.882v1.2H5V6.5Z",
    fill: "#161616"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgRecurringTaskTemplate);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/recurring-task-template.4fcc98ddc22e94913a9d60e2e3105f74.svg";